function LocationIcon({ color = '#959FAF', size = '16', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 8.33335C14.6666 11.0374 11.0709 14.4441 9.16094 16.063C8.48451 16.6363 7.51545 16.6363 6.83901 16.063C4.92904 14.4441 1.33331 11.0374 1.33331 8.33335C1.33331 4.65146 4.31808 1.66669 7.99998 1.66669C11.6819 1.66669 14.6666 4.65146 14.6666 8.33335Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <ellipse
        cx="8"
        cy="8.33331"
        rx="2"
        ry="2"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export default LocationIcon;
